import _ from "lodash";
import ACTIONS from "../actions/PricingTablesActions";

const initialState = {
    uploadPTModalOpen: false,
    addPTModalOpen: false,
    editPTModalOpen: false,
    deletePTWarning: false,
    pricingTableObjectV2: {
        name: "",
        description: "",
        currency: "USD",
        pricing_type: "TENANT",
        volume_aggregation_period: "MONTHLY",
        volume_aggregation_type: "",
        updated_by: "",
        base_price: 0,
    },
    aggregationTypeOptions: [
        { label: "Country", value: "COUNTRY" },
        { label: "Global", value: "GLOBAL"},
        { label: "None", value: "NONE"}
    ],
    addCountryPriceModalOpen: false,
    editCountryPriceModalOpen: false,
    deleteCountryPriceWarning: false,
    countryPriceForDelete: "",
    countryPriceObject: {
        price: "",
        countries: [],
        pricing_id: "",
        add: false,
        original_price: ""
    }
}

const AddEditPTReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.addEditPricingTableActionTypes.TOGGLE_UPLOAD_PRICING_MODAL: {
            let newState = _.cloneDeep(state);
            newState.uploadPTModalOpen = !newState.uploadPTModalOpen;

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.TOGGLE_ADD_PRICING_TABLE_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.addPTModalOpen = !newState.addPTModalOpen;
            // reset the form to placeholder values
            if (!newState.addPTModalOpen) {
                newState.pricingTableObjectV2 = initialState.pricingTableObjectV2;
            }

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.TOGGLE_EDIT_PRICING_TABLE_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.editPTModalOpen = !newState.editPTModalOpen;
            // reset the form to placeholder values
            if (!newState.editPTModalOpen) {
                newState.pricingTableObjectV2 = initialState.pricingTableObjectV2;
                newState.aggregationTypeOptions = initialState.aggregationTypeOptions;
            }

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.OPEN_EDIT_PRICING_TABLE_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTableObjectV2 = action.payload.pricingTableObjectV2;
            // restrict user changes to pricing table's vol agg if it contains a tiered pricing scheme
            if (action.payload.containsTieredPricingScheme) {
                newState.aggregationTypeOptions = [
                    { label: "None", value: "NONE"}
                ]
            }
            newState.editPTModalOpen = !newState.editPTModalOpen;

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.SETTING_PRICING_FORM_VALUE_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTableObjectV2[action.payload.name] = action.payload.value;
            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.SETTING_PRICING_FORM_DROPDOWN_V2: {
            let newState = _.cloneDeep(state);

            if (action.payload.option === null) {
                newState.pricingTableObjectV2[action.payload.change_obj.name] = initialState.pricingTableObjectV2[action.payload.change_obj.name];
            } else {
                newState.pricingTableObjectV2[action.payload.change_obj.name] = action.payload.option.value;
            }
            return newState;
        }

        case ACTIONS.addEditPricingTableActionTypes.SETTING_PRICING_FORM_DESCRIPTION_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTableObjectV2[action.payload.name] = action.payload.value;
            return newState;
        }

        case ACTIONS.addEditPricingTableActionTypes.TOGGLE_ADD_COUNTRY_PRICING_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.addCountryPriceModalOpen = !newState.addCountryPriceModalOpen;
            // reset the form to placeholder values
            if (newState.addCountryPriceModalOpen) {
                newState.countryPriceObject.pricing_id = action.payload;
                newState.countryPriceObject.add = true
            } else {
                newState.countryPriceObject = initialState.countryPriceObject;
            }

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.OPEN_EDIT_COUNTRY_PRICING_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.countryPriceObject = action.payload;
            newState.editCountryPriceModalOpen = !newState.editCountryPriceModalOpen;
            newState.countryPriceObject.original_price = newState.countryPriceObject.price;

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.CLOSE_COUNTRY_PRICING_MODAL_V2: {
            let newState = _.cloneDeep(state);
            newState.countryPriceObject = initialState.countryPriceObject;
            newState.editCountryPriceModalOpen = false;
            newState.addCountryPriceModalOpen = false;

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.SETTING_COUNTRY_PRICING_FORM_VALUE_V2: {
            let newState = _.cloneDeep(state);

            if (action.payload.name === "price") {
                newState.countryPriceObject[action.payload.name] = action.payload.value;

            //  Add Case
            } else if (newState.countryPriceObject.add) {
                newState.countryPriceObject[action.payload.name] = action.payload.value;

            //  Edit Case
            } else {
                const oldCountryList = newState.countryPriceObject[action.payload.name].map(obj => obj.country_code);

                // add new countries to the state
                action.payload.value.forEach(cc => {
                    if (!oldCountryList.includes(cc)) {
                        newState.countryPriceObject[action.payload.name].push({
                            'country_code': cc,
                            'country_price_id': ''
                        })
                    }
                });
                // filter out countries removed from the list
                newState.countryPriceObject[action.payload.name].forEach(country_obj => {
                    if (!action.payload.value.includes(country_obj.country_code)) {
                        newState.countryPriceObject[action.payload.name] =
                            newState.countryPriceObject[action.payload.name].filter(item => item.country_code !== country_obj.country_code)
                    }
                });
            }

            return newState
        }

        case ACTIONS.addEditPricingTableActionTypes.DELETE_WARNING_FOR_COUNTRY_PRICING_V2: {
            let newState = _.cloneDeep(state);
            newState.deleteCountryPriceWarning = !newState.deleteCountryPriceWarning;
            newState.countryPriceForDelete = action.payload;

            return newState;
        }

        case ACTIONS.apiActionsPricingTables.DELETE_WARNING_FOR_PRICING_V2: {
            let newState = _.cloneDeep(state);
            newState.deletePTWarning = !newState.deletePTWarning;

            return newState;
        }

        default:
            return state;
    }
}

export default AddEditPTReducer
